export default {
	GET_USER_INFO: (state, data) => {
		state.userInfo = data
	}
}


// WEBPACK FOOTER //
// ./src/store/mp/user_center/users/mutations.js